import { render, staticRenderFns } from "./ImportTasks.vue?vue&type=template&id=f153542c&scoped=true"
import script from "./ImportTasks.vue?vue&type=script&lang=js"
export * from "./ImportTasks.vue?vue&type=script&lang=js"
import style0 from "./ImportTasks.vue?vue&type=style&index=0&id=f153542c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f153542c",
  null
  
)

export default component.exports